/* global axios */
import ApiClient from '../ApiClient';

// T-246: o funil da operação no painel ao vivo. Sem período: ao vivo é agora.
class FunilAoVivoAPI extends ApiClient {
  constructor() {
    super('fandata/funil_ao_vivo', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new FunilAoVivoAPI();
